const st4 = () =>
  Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);

export const createUuid = () => {
  return `${st4()}${st4()}-${st4()}-${st4()}-${st4()}-${st4()}${st4()}${st4()}`;
};
